import { useEffect, useLayoutEffect, useState } from 'react';
import debounce from 'lodash/debounce';
const useMobile = breakpoint => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (window.innerWidth < breakpoint) {
        setIsMobile(true);
      }
    }
  }, []);
  useLayoutEffect(() => {
    if (typeof window !== 'undefined') {
      const updateSize = () => {
        setIsMobile(window.innerWidth < breakpoint);
      };
      window.addEventListener('resize', debounce(updateSize, 250));
      return () => window.removeEventListener('resize', updateSize);
    }
  }, []);
  return isMobile;
};
export default useMobile;